import styles from "./Skeleton.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import React, { ReactNode } from "react";
import wrapperHOC from "@Utils/wrapperHOC";

interface SkeletonLoaderProps {
  children?: ReactNode;
  width?: string;
  height?: string;
  mb?: string;
  mt?: string;
  addBorderRadius?: boolean;
  showSkeleton?: boolean;
}

const Skeleton: React.FC<SkeletonLoaderProps> = ({
  children,
  width,
  height,
  mb,
  mt,
  addBorderRadius,
  showSkeleton = true,
}: SkeletonLoaderProps) =>
  showSkeleton ? (
    <div
      className={formatClassNames(styles.skeleton, addBorderRadius && styles.addBorderRadius)}
      style={{
        width,
        height,
        marginBottom: mb,
        marginTop: mt,
      }}
    >
      {children}
    </div>
  ) : (
    <>{children}</>
  );

export default wrapperHOC(Skeleton, {
  componentName: "Skeleton-Global",
  showForChina: true,
});
